<template>
    <div class="section-confirm">
        <div class="container text-center">
            <div class="logo-container">
                <img class="n-logo" width="130" height="40" src="img/logotipo_mod2.png" alt="U4CROWD" />
            </div>
            <div class="row justify-content-md-center">
                <div class="col-md-12 col-lg-8">
                    <h4 class="title">{{$t('unconfirm.message')}}</h4>
                    <h5 class="title">{{$t('unconfirm.redirect')}}</h5>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'unconfirm',
  components: {
  },
  mounted() {
    setTimeout(() => {
        this.$router.push('/') 
    }, 5000);
  }
};
</script>
<style>
</style>
